module.exports = __webpack_public_path__ + "static/case-study-banner-overlay-6c10b3de2a47eb4cfae8aff22d590766.jpg";